import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import ViewKanbanIcon from "@mui/icons-material/ViewKanban";
import SearchIcon from "@mui/icons-material/Search";
import GroupIcon from "@mui/icons-material/Group";

const routes = [
  { label: "Home", value: "/", icon: <DashboardIcon /> },
  { label: "Prospects", value: "/prospects", icon: <PeopleIcon /> },
  { label: "Boards", value: "/boards", icon: <ViewKanbanIcon /> },
  { label: "Search", value: "/search/results", icon: <SearchIcon /> },
  { label: "Coaches", value: "/coaches", icon: <GroupIcon /> },
];

const MobileBottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const currentValue = React.useMemo(() => {
    const match = routes.find((r) =>
      r.value === "/"
        ? location.pathname === "/"
        : location.pathname.startsWith(r.value)
    );
    return match ? match.value : "/";
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    if (newValue && newValue !== currentValue) {
      navigate(newValue);
    }
  };

  return (
    <Paper
      elevation={8}
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        display: { xs: "block", md: "none" },
        zIndex: (theme) => theme.zIndex.appBar,
      }}
    >
      <BottomNavigation value={currentValue} onChange={handleChange} showLabels>
        {routes.map((r) => (
          <BottomNavigationAction
            key={r.value}
            label={r.label}
            value={r.value}
            icon={r.icon}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
};

export default MobileBottomNav;
